<template>
    <div class="popup-contract popup-all">
        <div class="popup-container">
            <div class="popup-vue">
                <button class="popup-close" ref="popupAgreementClose" @click="popupClose()" style="background: transparent;">
                    <img src="/img/credit-landing-vue/popup-close.svg" alt="Close">
                </button>
                <div class="popup-title" v-html="__t('Згода на обробку персональних даних')"></div>
                <div class="popup-description content">
                    <div v-html="__t('Згода на обробку 1')"></div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

  export default {
    name: 'popup-contract',
    data() {
      return {

      }
    },
    methods: {
        __t(phrase) {
            return window.__t(phrase);
        },
        popupOpen: function() {
            this.$el.style.display = 'block';

            this.$nextTick(() => {
                this.$refs.popupAgreementClose.focus();
            });
        },
        popupClose: function() {
            this.$el.style.display = 'none';
        },

    }
  }

</script>